export default __webpack_public_path__ + "static/media/pic82.d471e6b3.jpg";